import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 8l4 8","key":"svg-0"}],["path",{"d":"M10 16l4 -8","key":"svg-1"}]]

/**
 * IconLetterXSmall
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbGV0dGVyLXgtc21hbGwiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTEwIDhsNCA4IiAvPgogIDxwYXRoIGQ9Ik0xMCAxNmw0IC04IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/letter-x-small
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconLetterXSmall = createReactComponent('outline', 'letter-x-small', 'LetterXSmall', __iconNode);

export default IconLetterXSmall;